import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokonkandarshancab() {



    const cardData = {

keyword: "Mumbai to Konkan Darshan Cab Booking",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Konkan Darshan Cab Booking services for families, pilgrims, beach lovers, nature enthusiasts, and group travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a memorable coastal journey through the beautiful Konkan region. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip bookings, customized Konkan tour packages, multi-day sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free travel experience covering the pristine beaches, ancient temples, sea forts, waterfalls, and cultural heritage of Maharashtra's picturesque Konkan coast.",

topPlaces: [
    {
        title: "Ganpatipule",
        description:
            "Ganpatipule is one of Konkan's most famous pilgrimage and beach destinations, renowned for the ancient self-manifested Ganpati Temple situated along the Arabian Sea. The golden sandy beach, clear waters, and peaceful surroundings attract families, devotees, and nature lovers throughout the year. Visitors can enjoy temple darshan, beach walks, local seafood, water activities, and spectacular sunsets while experiencing the unique blend of spirituality and coastal beauty."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a historic coastal city known for its beautiful beaches, mango orchards, ancient monuments, and rich cultural heritage. Popular attractions include Ratnadurg Fort, Thiba Palace, Mandvi Beach, and the birthplace of Lokmanya Tilak. Travelers also enjoy authentic Konkani cuisine and the world-famous Alphonso mangoes, making Ratnagiri an essential destination on a Konkan Darshan tour."
    },
    {
        title: "Tarkarli",
        description:
            "Tarkarli is one of Maharashtra's most beautiful beach destinations, famous for its crystal-clear waters, white sandy shoreline, and exciting water sports. Visitors can enjoy scuba diving, snorkeling, dolphin safaris, parasailing, and boating while exploring the vibrant marine life. The peaceful atmosphere and scenic coastline make Tarkarli a perfect destination for adventure seekers and family vacations."
    },
    {
        title: "Sindhudurg Fort",
        description:
            "Sindhudurg Fort is a magnificent sea fort built by Chhatrapati Shivaji Maharaj and stands as a symbol of Maratha naval strength. Surrounded by the Arabian Sea, the fort features massive walls, hidden entrances, ancient temples, and historical structures. Visitors reach the fort by boat and enjoy learning about its fascinating history while admiring panoramic coastal views."
    },
    {
        title: "Malvan",
        description:
            "Malvan is a charming coastal town known for its pristine beaches, seafood cuisine, historic monuments, and traditional Konkani culture. Tourists visit Malvan for its peaceful environment, boat rides, water sports, local markets, and nearby attractions such as Sindhudurg Fort and Rock Garden. The town offers an authentic coastal experience and is a highlight of any Konkan Darshan itinerary."
    },
    {
        title: "Vijaydurg Fort",
        description:
            "Vijaydurg Fort is one of Maharashtra's oldest and most strategically important sea forts, surrounded by the Arabian Sea on three sides. The fort is admired for its massive fortifications, hidden defense systems, and association with the Maratha Empire. Visitors explore its historic structures while enjoying beautiful sea views and the rich maritime heritage of the Konkan coast."
    },
    {
        title: "Harihareshwar",
        description:
            "Harihareshwar is a sacred pilgrimage and beach destination famous for the ancient Harihareshwar Temple dedicated to Lord Shiva and the scenic Arabian Sea coastline. Pilgrims perform the traditional pradakshina around the hill while tourists enjoy the peaceful beaches, rocky shores, and breathtaking sunsets. The destination combines spiritual significance with natural beauty."
    },
    {
        title: "Diveagar",
        description:
            "Diveagar is a peaceful beach town known for its clean shoreline, coconut and betel nut plantations, and serene atmosphere. The destination is ideal for family holidays, beach walks, bird watching, and relaxing away from crowded tourist spots. Visitors also explore the Suvarna Ganesh Temple and enjoy the traditional hospitality and cuisine of the Konkan region."
    },
    {
        title: "Dapoli",
        description:
            "Dapoli is a scenic hill and coastal destination often referred to as the Mini Mahabaleshwar of Konkan due to its pleasant climate and lush greenery. Nearby attractions include Murud Beach, Karde Beach, Ladghar Beach, ancient temples, and dolphin watching tours. The combination of beaches, hills, and historical sites makes Dapoli a favorite stop for Konkan travelers."
    },
    {
        title: "Guhagar",
        description:
            "Guhagar is a picturesque coastal town famous for its long sandy beach, ancient temples, coconut groves, and peaceful surroundings. Visitors explore the Vyadeshwar Temple, Hedvi Ganesh Temple, nearby lighthouses, and traditional Konkani villages while enjoying the calm atmosphere. The natural beauty, spiritual heritage, and authentic local culture make Guhagar a perfect conclusion to a Mumbai to Konkan Darshan cab journey."
    }
],



services: [
{
name: "Mumbai to Konkan Darshan Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Konkan Darshan Cab Booking service for comfortable, safe, and memorable journeys across the scenic Konkan coastline. Whether you are planning a family vacation, beach holiday, temple pilgrimage, weekend getaway, honeymoon, or corporate trip, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our experienced chauffeurs cover popular Konkan destinations including Alibag, Diveagar, Harihareshwar, Dapoli, Guhagar, Ganpatipule, Ratnagiri, Tarkarli, Malvan, Sindhudurg, and other coastal attractions with flexible travel plans. Enjoy doorstep pickup, one way and round trip options, multi-day tour packages, transparent pricing, sightseeing assistance, and 24x7 customer support for a relaxing and enjoyable Konkan Darshan experience."
},
{
name: "Mumbai to Konkan Darshan Cab",
description: "Mumbai Airport Cab provides Mumbai to Konkan Darshan Cab service with comfortable AC vehicles, professional drivers, affordable fares, and customized travel plans for exploring the beautiful beaches, temples, forts, and natural attractions of the Konkan region."
},
{
name: "Mumbai Konkan Darshan Taxi Service",
description: "Book Mumbai Konkan Darshan Taxi Service with Mumbai Airport Cab for reliable transportation across the Konkan coast with Sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller options for families and groups."
},
{
name: "Konkan Darshan Cab from Mumbai",
description: "Choose Konkan Darshan Cab from Mumbai for a comfortable coastal journey with experienced chauffeurs, clean vehicles, flexible itineraries, and affordable sightseeing packages."
},
{
name: "Mumbai to Konkan Tour Cab",
description: "Mumbai Airport Cab offers Mumbai to Konkan Tour Cab service for beach holidays, temple visits, sightseeing tours, family vacations, and multi-day Konkan travel experiences."
},
{
name: "Mumbai Konkan Sightseeing Cab",
description: "Book Mumbai Konkan Sightseeing Cab with Mumbai Airport Cab and enjoy convenient travel to famous Konkan beaches, forts, temples, waterfalls, and scenic coastal destinations."
},
{
name: "Mumbai to Konkan Holiday Cab",
description: "Mumbai Airport Cab provides Mumbai to Konkan Holiday Cab service for weekend trips, family holidays, honeymoon tours, and group travel with comfortable AC vehicles."
},
{
name: "Konkan Darshan Car Rental from Mumbai",
description: "Choose Konkan Darshan Car Rental from Mumbai with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for a safe and enjoyable road trip."
},
{
name: "Mumbai to Konkan Road Trip Cab",
description: "Enjoy a scenic coastal drive with Mumbai to Konkan Road Trip Cab service featuring flexible travel schedules, experienced drivers, and comfortable long-distance vehicles."
},
{
name: "Mumbai to Konkan Package Cab",
description: "Mumbai Airport Cab offers Mumbai to Konkan Package Cab with complete travel solutions for beach tours, temple darshan, sightseeing, family vacations, and holiday packages."
},
{
name: "Mumbai Konkan Travel Cab Service",
description: "Book Mumbai Konkan Travel Cab Service for affordable and reliable transportation with clean AC vehicles, professional chauffeurs, and customized Konkan travel plans."
},
{
name: "Mumbai to Konkan Outstation Cab",
description: "Mumbai Airport Cab provides Mumbai to Konkan Outstation Cab service with one way and round trip options, premium vehicles, and convenient door-to-door travel."
},
{
name: "Mumbai Konkan Tourist Cab",
description: "Choose Mumbai Konkan Tourist Cab for sightseeing tours across the Konkan region with experienced drivers, spacious vehicles, and comfortable travel arrangements."
},
{
name: "Mumbai Konkan Trip Taxi Booking",
description: "Mumbai Airport Cab offers Mumbai Konkan Trip Taxi Booking with instant confirmation, affordable pricing, multiple vehicle options, and flexible travel schedules."
},
{
name: "Mumbai Konkan Private Cab Hire",
description: "Book Mumbai Konkan Private Cab Hire for exclusive chauffeur-driven travel with personalized itineraries, premium comfort, and convenient pickup and drop services."
},
{
name: "Mumbai Konkan Beach Tour Cab",
description: "Mumbai Airport Cab provides Mumbai Konkan Beach Tour Cab service covering popular beaches and coastal attractions with safe, comfortable, and affordable travel."
},
{
name: "Mumbai Konkan Family Tour Cab",
description: "Travel with Mumbai Konkan Family Tour Cab for enjoyable family vacations featuring spacious vehicles, experienced drivers, and customized sightseeing packages."
},
{
name: "Mumbai Konkan Innova Cab",
description: "Mumbai Airport Cab offers Mumbai Konkan Innova Cab service with spacious seating, comfortable interiors, and ample luggage space for family and group travel."
},
{
name: "Mumbai Konkan SUV Cab",
description: "Choose Mumbai Konkan SUV Cab for premium travel comfort with spacious seating, reliable performance, and smooth journeys across the Konkan coastline."
},
{
name: "Mumbai Konkan Tempo Traveller Booking",
description: "Mumbai Airport Cab provides Mumbai Konkan Tempo Traveller Booking for large families, corporate groups, pilgrimages, and holiday tours with comfortable AC seating and professional chauffeurs."
}
],

tableData: [
["Mumbai to Konkan Darshan Cab Booking","Mumbai to Konkan Darshan Cab"],
["Mumbai Konkan Darshan Taxi Service","Konkan Darshan Cab from Mumbai"],
["Mumbai to Konkan Tour Cab","Mumbai Konkan Sightseeing Cab"],
["Mumbai to Konkan Holiday Cab","Konkan Darshan Car Rental from Mumbai"],
["Mumbai to Konkan Road Trip Cab","Mumbai to Konkan Package Cab"],
["Mumbai Konkan Travel Cab Service","Mumbai to Konkan Outstation Cab"],
["Mumbai Konkan Tourist Cab","Mumbai Konkan Trip Taxi Booking"],
["Mumbai Konkan Private Cab Hire","Mumbai Konkan Beach Tour Cab"],
["Mumbai Konkan Family Tour Cab","Mumbai Konkan Innova Cab"],
["Mumbai Konkan SUV Cab","Mumbai Konkan Tempo Traveller Booking"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Konkan Darshan Cab Booking",
WhyChoosedescription: "Mumbai Airport Cab Service offers dependable Mumbai to Konkan Darshan Cab Booking for families, tourists, pilgrims, couples, and groups exploring the beautiful Konkan coastline."
},
{
WhyChooseheading: "Complete Konkan Tour Travel Solution",
WhyChoosedescription: "Our cab service provides comfortable transportation to popular Konkan destinations including Ganpatipule, Ratnagiri, Tarkarli, Malvan, Sindhudurg, Harihareshwar, Shrivardhan, and Dapoli."
},
{
WhyChooseheading: "Perfect for Family Vacations and Coastal Tours",
WhyChoosedescription: "Konkan is known for its pristine beaches, temples, forts, seafood, and scenic landscapes, making it an ideal destination for memorable holidays."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "Customized Konkan Tour Packages",
WhyChoosedescription: "Whether you require a weekend getaway, multi-day Konkan tour, beach holiday, or customized itinerary, we provide flexible travel solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Experienced Drivers for Coastal Routes",
WhyChoosedescription: "Our professional drivers are familiar with Konkan highways, coastal roads, and tourist destinations, ensuring safe and comfortable travel."
},
{
WhyChooseheading: "Ideal for Groups and Sightseeing Tours",
WhyChoosedescription: "From solo travelers to large groups, we provide suitable vehicles for beach tours, temple visits, sightseeing trips, and family vacations."
}
]
};

const faqData = [
{
question: "What destinations are covered in Mumbai to Konkan Darshan Cab Booking?",
answer: "Popular destinations include Ganpatipule, Ratnagiri, Malvan, Tarkarli, Sindhudurg, Shrivardhan, Harihareshwar, Dapoli, Guhagar, and other Konkan attractions."
},
{
question: "Can I book a customized Konkan Darshan package?",
answer: "Yes, customers can customize their itinerary according to the destinations, duration, and sightseeing preferences."
},
{
question: "Which vehicle is suitable for Konkan Darshan travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular options depending on passenger count and luggage requirements."
},
{
question: "Are multi-day Konkan tours available?",
answer: "Yes, we provide weekend trips, 3-day, 4-day, and customized multi-day Konkan Darshan tour packages."
},
{
question: "Can families book this service for vacations?",
answer: "Yes, families frequently choose our Mumbai to Konkan Darshan Cab Booking for beach holidays, sightseeing tours, and cultural experiences."
},
{
question: "Do you provide Tempo Travellers for group tours?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and sightseeing tours."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Can sightseeing locations be added during the trip?",
answer: "Yes, customers can include beaches, temples, forts, waterfalls, local markets, and other attractions in their itinerary."
},
{
question: "Is advance booking recommended for Konkan tours?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning, especially during holiday seasons."
},
{
question: "How can I book a Mumbai to Konkan Darshan Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Nitin Sawant",
feedback:
"Our Konkan family tour was wonderful with Mumbai Airport Cab Service. The vehicle was comfortable, the driver was knowledgeable about the routes, and we enjoyed every destination on our trip.",
rating: 5
},
{
id: 2,
name: "Mrs. Pooja Naik",
feedback:
"We booked a Mumbai to Konkan Darshan Cab for a beach vacation. The service was excellent, the cab was clean, and the journey was smooth throughout the tour.",
rating: 5
}
];































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Konkan Darshan Cab Booking",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-konkan-darshan-cab.jpg",
"description": "Book Mumbai to Konkan Darshan cab booking for a scenic coastal holiday trip. Mumbai Airport Cabs offers reliable taxi service for Konkan sightseeing with experienced drivers, comfortable vehicles, flexible tour packages, and affordable pricing for road trips from Mumbai to Konkan.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-konkan-darshan-cab-booking"
}
};









    return (
        <div>

<Helmet>
  <title>Mumbai to Konkan Darshan Cab Booking | Tour Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Konkan Darshan cab booking for a memorable coastal road trip. Comfortable taxi service with professional drivers, sightseeing packages, and affordable travel options across Konkan."
/>

<meta
 name="keywords"
 content="mumbai to konkan darshan cab booking, mumbai to konkan darshan cab, mumbai konkan darshan taxi service, konkan darshan cab from mumbai, mumbai to konkan tour cab, mumbai konkan sightseeing cab, mumbai to konkan holiday cab, konkan darshan car rental from mumbai, mumbai to konkan road trip cab, mumbai to konkan package cab, mumbai konkan travel cab, konkan tour from mumbai taxi, coastal road trip cab mumbai, outstation konkan cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitokonkandarshancab;